'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _AppDisclaimer = require('./AppDisclaimer.css');

var _AppDisclaimer2 = _interopRequireDefault(_AppDisclaimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppDisclaimer = (_dec = (0, _reactCssModules2.default)(_AppDisclaimer2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AppDisclaimer, _Component);

  function AppDisclaimer() {
    (0, _classCallCheck3.default)(this, AppDisclaimer);
    return (0, _possibleConstructorReturn3.default)(this, (AppDisclaimer.__proto__ || (0, _getPrototypeOf2.default)(AppDisclaimer)).apply(this, arguments));
  }

  (0, _createClass3.default)(AppDisclaimer, [{
    key: 'render',
    value: function render() {
      // const disclaimIcon = require( '../../../static/images/investment-advisor-icon.png' )

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'ad-img-bckgrnd' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12 },
              _react2.default.createElement(
                'div',
                { styleName: 'ad-cntr' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'ad-cpy' },
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'ad-hl' },
                    'Disclaimer: As You Sow is not an investment adviser'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'ad-p' },
                    'As You Sow is not an investment adviser as that term is defined under federal and state (California) laws and regulations. As You Sow is a tax-exempt, nonprofit organization dedicated to educating and empowering shareholders to change corporations for the good through the collection, analysis and dissemination of relevant information to the public, free of charge. As You Sow does not provide financial planning, legal or tax advice. Nothing on this website shall constitute or be construed as an offering of financial instruments, or as investment advice or investment recommendations.',
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.legal,
                        title: 'Legal disclaimer'
                      },
                      _react2.default.createElement(
                        'span',
                        { styleName: 'wht' },
                        'See our full disclaimer',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return AppDisclaimer;
}(_react.Component)) || _class);
exports.default = AppDisclaimer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/AppDisclaimer/AppDisclaimer.js
// module id = 1346
// module chunks = 0